import { Bell } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import Notifications from "../components/Notifications/Notifications";
import { ApiService } from "../utils/ApiService";

export default function Header() {

  const dropdownRef = useRef(null);
  const [open, setOpen] = useState(false)
  const [notifications, setNotifications] = useState([]);
  const [page, setPage] = useState(0); // 0-based
  const [limit] = useState(10);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);

  console.log("OPEN --> ", open)
  
  useEffect(() => {
    
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const getHeaderTitle = () => {
    const path = window.location.pathname;
    const title = path.split("/").pop();

    let words = title.split("-");
    let capitalizedTitle = words.map((word, index) => {
      if (index === 0) return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      else return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(" ");

    return capitalizedTitle;
  }

  const fetchNotifications = async (pageToLoad = 0) => {
    try {
      if (loading || !hasMore) return;
  
      setLoading(true);
  
      const token = localStorage.getItem("auth_token");
  
      const res = await ApiService.get(
        "admin/notifications",
        {
          limit,
          offset: pageToLoad * limit,
        },
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
  
      const newNotifications = res.notifications || [];
  
      setNotifications(prev =>
        pageToLoad === 0 ? newNotifications : [...prev, ...newNotifications]
      );
  
      // If less than limit → no more data
      if (newNotifications.length < limit) {
        setHasMore(false);
      }
  
      setPage(pageToLoad);
    } catch (err) {
      console.error("Error fetching notifications", err);
    } finally {
      setLoading(false);
    }
  };
  
  const handleBellBtnClick = async () => {
    setOpen(prev => !prev);
  
    if (!open) {
      // Reset when opening
      setNotifications([]);
      setPage(0);
      setHasMore(true);
      fetchNotifications(0);
    }
  };
  

  return (
    <div className="w-full bg-gray-100 p-6">
      <div className="bg-white flex items-center justify-between rounded-md px-4 py-2 shadow-sm">
        <div className="flex items-center ml-auto">
          <div className="relative" ref={dropdownRef}>
            {/* <button 
              className="p-2 hover:bg-gray-100 rounded-full"
              onClick={handleBellBtnClick}
            >
              <Bell size={20} />
            </button> */}

            {open && (
              <Notifications
                notifications={notifications}
                hasMore={hasMore}
                loading={loading}
                onLoadMore={() => fetchNotifications(page + 1)}
              />
            )}
          </div>

          <div className="ml-3 w-10 h-10 flex items-center justify-center bg-gray-300 rounded-full text-sm font-semibold">
            A
          </div>
        </div>
      </div>
    </div>
  );
}
